import { Tag, Tooltip } from 'antd'
import { menuBuilderGpReviewCopy as copy } from 'src/constants/menuBuilderCopy'
import { buildGpReviewBannerText } from 'src/utils/recipeGpReview'

const GpChangedListBadge = ({ recipe }) => {
  const bannerLine = recipe ? buildGpReviewBannerText(recipe, copy) : null
  const tooltip = bannerLine
    ? `${bannerLine}. ${copy.needsReviewHint}`
    : copy.needsReviewHint

  return (
    <Tooltip title={tooltip}>
      <Tag
        style={{
          backgroundColor: '#fff7e6',
          borderColor: '#ffd591',
          color: '#d48806',
          fontSize: '10px',
          lineHeight: '18px',
          margin: 0,
          fontWeight: 600,
        }}
      >
        {bannerLine || copy.changedBadge}
      </Tag>
    </Tooltip>
  )
}

export default GpChangedListBadge
